<template>
  <v-dialog v-model="dialog" scrollable width="650">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm đầu mục thiết bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <CategoryForm ref="categoryForm" :categoryData="categoryData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CategoryForm from '@/modules/facility/category/CategoryForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'CategoryNewDialog',
  components: { CategoryForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      categoryData: {}
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.categoryData = {}
      }
    }
  },
  methods: {
    ...mapActions('FacilityCategories', ['createCategory']),
    cancel() {
      this.dialog = false
      this.categoryData = {}
      if (this.$refs.categoryForm) {
        this.$refs.categoryForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.categoryForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.categoryForm.getData()
        delete payload.id
        await this.createCategory(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
